/* Header parity for simple dropdowns.

   Broadcast only drops the transparent header when a mega menu opens, because
   only the mega menu is wide enough to sit behind the whole bar. A menu item
   with a single column of links opens a small panel instead, and the header
   was left transparent, so that one item behaved unlike all the others.

   The theme keys every transparent-header rule off 'meganav--visible' on the
   header wrapper, so putting the same class on for simple dropdowns reuses
   the theme's own styling rather than overriding it. A MutationObserver runs
   after the theme's own handler, which removes the class again for these
   items, so the two do not fight. */
(function () {
  var WRAPPER = '[data-header-wrapper]';
  var VISIBLE = 'is-visible';
  var MEGANAV = 'meganav--visible';

  function simpleDisclosures(root) {
    return (root || document).querySelectorAll('hover-disclosure.parent:not(.grandparent)');
  }

  function anyOpen(wrapper) {
    var items = simpleDisclosures(wrapper);
    for (var i = 0; i < items.length; i++) {
      if (items[i].classList.contains(VISIBLE)) return true;
    }
    return false;
  }

  function watch(item) {
    if (item.dataset.bakkelegHeader === 'true') return;
    item.dataset.bakkelegHeader = 'true';

    var wrapper = item.closest(WRAPPER);
    if (!wrapper) return;

    new MutationObserver(function () {
      if (item.classList.contains(VISIBLE)) {
        wrapper.classList.add(MEGANAV);
      } else if (!anyOpen(wrapper)) {
        wrapper.classList.remove(MEGANAV);
      }
    }).observe(item, {attributes: true, attributeFilter: ['class']});
  }

  function bind(scope) {
    var items = simpleDisclosures(scope);
    for (var i = 0; i < items.length; i++) watch(items[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
})();
